import { render, staticRenderFns } from "./Search.vue?vue&type=template&id=5573ba30&"
import script from "./Search.vue?vue&type=script&lang=js&"
export * from "./Search.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5573ba30')) {
      api.createRecord('5573ba30', component.options)
    } else {
      api.reload('5573ba30', component.options)
    }
    module.hot.accept("./Search.vue?vue&type=template&id=5573ba30&", function () {
      api.rerender('5573ba30', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/administration/configuration/Search.vue"
export default component.exports